import { getAllFruitTypeOptions } from "@/api/fruit_type";

const state = {
    fruitTypeOpts: null
};

const mutations = {
    SET_FRUIT_TYPE_OPTS: (state, data) => {
        state.fruitTypeOpts = data;
    },
};

const actions = {
    async getFruitTypeOpts({ commit }, data) {
        let res = await getAllFruitTypeOptions({ ...data });
        if (res) {
            commit("SET_FRUIT_TYPE_OPTS", res); 
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/vuex/modules/fruit_type.js